export default __webpack_public_path__ + "static/media/lifebar1.6f4a728f.PNG";